import React from 'react';
import './LoanAgreement.css';

const LoanAgreement = ({
  date = "___",
  month = "________",
  year = "__",
  lenderName = "Vetrivikas Capital Trust",
  lenderAddress = "25, Arunachalashwara 3rd Cross Street, HMS Colony, 1st Main Road, Kokklappi, Madurai - 625016",
  borrowerName = "[BORROWER NAME]",
  borrowerAddress = "[Address]",
  loanAmount = "__________",
  jewellerName = "[Jeweller Name]",
  jewellerAddress = "[Jeweller Address]",
  repaymentFrequency = "[monthly]",
  tenureMonths = "[tenure]",
  disbDate = "[Disb Date]",
  interestRate = "24%",
  interestType = "[simple/compounded]",
  noticePeriod = "[15]",
  jurisdictionCity = "[City]"
}) => {
  return (
    <>
    <div className="loan-agreement">
      <h1 className="title">LOAN AGREEMENT</h1>
      
      <p className="intro">
        This Loan Agreement ("Agreement") is made and entered into on this {disbDate} day of {month}, {year}, by and between:
      </p>
      
      <div className="parties">
        <p>
          <strong>{lenderName}</strong>, a Trust incorporated under the Indian Trust (Amendment) Act, 2016, having its registered office at <strong>{lenderAddress}</strong>, hereinafter referred to as the "Lender" (which expression shall, unless repugnant to the context, include its successors and assigns),
        </p>
        <p className="and">AND</p>
        <p>
          <strong>{borrowerName}</strong>, residing at <strong>{borrowerAddress}</strong>, hereinafter referred to as the "Borrower" (which expression shall, unless repugnant to the context, include his/her heirs, executors, and legal representatives).
        </p>
      </div>
      
      <h2 className="whereas">WHEREAS</h2>
      <div className="whereas-clauses">
        <p>A. The Borrower has approached the Lender for a loan to purchase gold jewellery.</p>
        <p>B. The Lender has agreed to extend such loan upon the terms and conditions hereinafter appearing.</p>
      </div>
      
      <h2 className="now-therefore">NOW, THEREFORE, IT IS AGREED AS FOLLOWS:</h2>
      
      <div className="terms">
        <div className="term">
          <h3>1. Loan Amount</h3>
          <p>The Lender agrees to lend the Borrower a sum of INR <strong>{loanAmount}</strong></p>
        </div>
        
        <div className="term">
          <h3>2. Disbursement</h3>
          <p>The Loan Amount shall be disbursed directly to the approved jewellery vendor, <strong>_________________________________________________________________________</strong>, located at <strong>____________________________________________________________________________________________________</strong>, for the exclusive purpose of purchasing gold jewellery.</p>
        </div>
        
        <div className="term">
          <h3>3. Purpose</h3>
          <p>The loan shall be utilised solely for the purchase of gold jewellery and for no other purpose.</p>
        </div>
        
        <div className="term">
          <h3>4. Tenure and Repayment</h3>
          <p>The loan shall be repaid in <strong>{repaymentFrequency}</strong> instalments over a period of <strong>{tenureMonths} months</strong>, commencing from <strong>{disbDate}</strong>.</p>
        </div>
        
        <div className="term">
          <h3>5. Interest</h3>
          <p>Interest shall accrue on the Loan Amount at the rate of <strong>{interestRate}% per annum</strong> <strong>{interestType}</strong> and shall be payable with each instalment.</p>
        </div>
        
        <div className="term">
          <h3>6. Security</h3>
          <p>The gold jewellery purchased shall be pledged with the Lender under a separate Pledge Agreement.</p>
        </div>
        
        <div className="term">
          <h3>7. Events of Default</h3>
          <p>a) Failure to pay any instalment on due date</p>
          <p>b) Breach of terms and conditions of this Agreement or the Pledge Agreement</p>
          <p>c) If the Borrower becomes insolvent or declared bankrupt</p>
        </div>
        
        <div className="term">
          <h3>8. Consequences of Default</h3>
          <p>Upon default, the Lender shall be entitled to enforce the pledge and recover dues by sale or auction of the pledged jewellery after issuing a <strong>{noticePeriod}-day</strong> notice.</p>
        </div>
        
        <div className="term">
          <h3>9. Miscellaneous</h3>
          <p>a) This Agreement shall be governed by the laws of India.</p>
          <p>b) Jurisdiction for any dispute shall be the courts at <strong>{jurisdictionCity}</strong>.</p>
        </div>
      </div>
      
      <div className="signatures">
        <p className="in-witness">IN WITNESS WHEREOF, the parties hereto have executed this Agreement as of the date first above written.</p>
        
        <div className="signature-blocks">
          <div className="signature-block">
            <p className="signature-title">Authorized Signatory</p>
            <p className="signature-org">{lenderName}</p>
            <div className="signature-line">_________________________</div>
          </div>
          
          <div className="signature-block">
            <p className="signature-title">Borrower</p>
            <div className="signature-line">_________________________</div>
          </div>
        </div>
        
        <div className="witness">
          <div style={{width:'50%'}}></div>
          <div style={{width:'50%'}}><p>Witness</p>
          <div className="signature-line">_________________________</div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default LoanAgreement;